@if (filteredNotifications) {
  <div
    #wrapper
    class="loren-notifications-panel mat-drawer-inner-container notifications-wrapper overflow-hidden"
    >
    <div>
        <mat-card-title translate class="loren-notifications-panel-title">
          {{ "user.notifications" | transloco }}
          <button mat-icon-button (click)="handleBackClick()" class="float-right">
            <mat-icon color="primary">close</mat-icon>
          </button>
        </mat-card-title>
    </div>
    @if (allNotifications?.length > 0) {
        <mat-form-field class="w-100 loren-form-field">
          <mat-label>{{ "operations.search" | transloco }}</mat-label>
          <input
            class="text-body"
            matInput
            name="searchString"
            [(ngModel)]="searchString"
            (ngModelChange)="handleSearch()"
            />
        </mat-form-field>
    }
    <div class="loren-notifications-panel-mark-read">
      @if (pushPermission$ | async; as permission) {
        <button
          (click)="handlePushPermissionClick()"
          mat-icon-button
          [matTooltip]="'notifications.push_status_' + permission | transloco"
          >
          <mat-icon color="primary">
            @switch (permission) {
              @case ('granted') { notifications_active }
              @case ('denied') { notifications_off }
              @default { notifications }
            }
          </mat-icon>
        </button>
      }
      <button
        (click)="markAllNotificationsAsRead()"
        mat-icon-button
        matTooltip="{{ 'notifications.mark_all_as_read_tooltip' | transloco }}"
        >
        <mat-icon color="primary">mark_email_read</mat-icon>
      </button>
    </div>
    <!-- Display "No new notification" message when there are no new notifications but old notifications exist -->
    @if (!hasNewNotifications && allNotifications?.length > 0) {
      <div class="loren-notifications-panel-no-new-message">
        <div class="no-new-notification-content">
          <mat-icon color="primary">notifications_none</mat-icon>
          <span>{{ 'notifications.no_new_notifications' | transloco }}</span>
        </div>
      </div>
    }
    @if ((detailsOutletState$ | async).visible) {
      <cdk-virtual-scroll-viewport
        cdkScrollable
        class="notification-scroller"
        [itemSize]="notificationItemSize"
        >
        <mat-action-list *cdkVirtualFor="let notification of filteredNotifications;">
            <mat-list-item
              class="loren-notifications-panel-item"
              (click)="handleNotificationClick(notification)"
              >
              <mat-icon [class.unread]="!notification.seen" class="icon">
                {{ notification.icon }}
              </mat-icon>
              <div class="loren-notifications-panel-item-info">
                <span>
                  {{ notification.title }}
                </span>
                <p>
                  <span>{{ notification.notificationTime | lorenDate }}</span>
                  <br />
                  <span> {{ notification.content }}</span>
                </p>
            </div>
          </mat-list-item>
      </mat-action-list>
    </cdk-virtual-scroll-viewport>
  }
</div>
}
